/* eslint-disable @typescript-eslint/no-redeclare -- intentionally naming the variable the same as the type */ 
export const StyledDateTimeInputsType = {
    primary: "primary" as const
};

export type StyledDateTimeInputsType = typeof StyledDateTimeInputsType[keyof typeof StyledDateTimeInputsType];
